import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, change } from 'redux-form';
import { debounce } from 'lodash';

import { ROSTER_CURRENT_BALANCE_FORM_NAME } from 'Common/FormEnum';
import { Filter, Main } from 'Containers/';
import { RosterCurrentBalanceForm } from './components/RosterCurrentBalanceForm';
import { TitledCard, LoadingPage } from 'Components/';
import {
  RosterCurrentBalanceFieldEnum as Fields,
  ReportFieldEnum as CommonReportFields,
} from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTable';
import {
  getGrades,
  getTeachers,
  getReport,
  clearReport,
  clearErrors,
  downloadReport,
} from './state/roster/actions';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { getSelectedStatuses } from './helpers/statusFormatter';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  toastType,
  createToast,
  toastError,
  errorToast,
} from 'Common/ToastHelper';
import { ExportFormatType } from 'Common/Constants/Enumeration/ExportFormatType';
import { ExportTypeDropdownName } from 'Common/Constants/exportTypeDropdownName';
import { FileExtensions } from 'Common/Constants/Enumeration/FileExtensions';

class RosterCurrentBalanceContainer extends Component {
  state = {
    selectedSites: [],
    allSites: [],
    ExportType: null,
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: ROSTER_CURRENT_BALANCE_FORM_NAME,
        saveButtonProps: {
          content: 'Submit',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getGrades();
  }

  handleSiteChange = (values) => {
    const { grades, change } = this.props;
    change(
      ROSTER_CURRENT_BALANCE_FORM_NAME,
      Fields.Grade,
      grades[0] ? grades[0].value : ''
    );
    change(ROSTER_CURRENT_BALANCE_FORM_NAME, Fields.Teacher, 'ALL');
    this.setState({
      selectedSites: values,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { selectedSites } = this.state;
    const { report } = this.props;

    if (selectedSites !== prevState.selectedSites) {
      this.props.getTeachers(selectedSites);
      this.getGradesDebounced(selectedSites);
    }

    if (report && prevProps && prevProps.report !== report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        if (this.state.ExportType === ExportFormatType.PortableDocFormat) {
          ReportGeneration(report, 'Roster Current Balance Report');
        }
      }
      this.props.clearReport();
    }

    if (errorToast(this.props, prevProps, 'errors')) {
      this.props.clearErrors();
    }
  }

  statusCheckboxes = () => {
    return Object.values(StatusEnum)
      .filter((f) => f !== '0')
      .map((value) => ({
        name: `Statuses${value}`,
        label: value,
        checked: true,
      }));
  };

  shouldCustomFiltersDisable = () => {
    return this.props.formValues
      ? !this.props.formValues[Fields.UseCustomBalanceFilter]
      : true;
  };

  handleSubmit = (values) => {
    const { selectedSites, allSites } = this.state;
    const { getReport, downloadReport } = this.props;
    if (selectedSites.length === 0) {
      toastError('You must select at least one site');
      return;
    }
    // Extract the export type and store it in state to determine if reportGeneration must be called
    const ExportType = values[ExportTypeDropdownName];
    this.setState({
      ExportType: ExportType,
    });

    const model = {
      ...values,
      [Fields.AllStatusesChecked]: values.All,
      [Fields.Statuses]: getSelectedStatuses(values),
      [Fields.Sites]: this.state.selectedSites,
      [Fields.AllSitesChecked]: allSites.length === selectedSites.length,
    };

    ExportType !== ExportFormatType.PortableDocFormat
      ? downloadReport(
          model,
          ExportType,
          `RosterBalanceReport.${FileExtensions[ExportType]}`
        )
      : getReport(model);
  };

  setGridSites = (sites) => {
    this.setState({
      allSites: sites,
    });
  };

  getGrades = () => {
    const { getGrades } = this.props;
    getGrades(this.state.selectedSites);
  };
  getGradesDebounced = debounce(this.getGrades, 500);

  initialValues = () => {
    const { grades } = this.props;
    let initialValues = {
      [Fields.ShowBalance]: true,
      [Fields.ShowStatus]: true,
      [Fields.Grade]: grades[0] ? grades[0].value : '',
      [Fields.AccountBalanceType]: 0,
      [Fields.Teacher]: 'ALL',
      [Fields.UseCustomBalanceFilter]: false,
      [Fields.SortBy]: 0,
      [Fields.CustomBalanceFilter]: 0,
      [Fields.BalanceAmount]: '0.00',
      [Fields.ExportType]: ExportFormatType.PortableDocFormat,
      [Fields.ShowParentContactInformation]: false,
      [CommonReportFields.IncludeNonLeaStudents]: true,
    };

    this.statusCheckboxes().forEach((x) => {
      Object.defineProperty(initialValues, `${x.name}`, {
        value: x.checked,
        writable: true,
        enumerable: true,
      });
    });
    return initialValues;
  };
  render() {
    const { teachers, grades, loading, loadingGrades } = this.props;
    return (
      <Fragment>
        {loading ? <LoadingPage /> : undefined}
        <Filter title={'Roster/Current Balance'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Sites'}>
            <SelectSitesTable
              onChange={this.handleSiteChange}
              getSitesCallback={(sites) => this.setState({ allSites: sites })}
            />
          </TitledCard>
          <RosterCurrentBalanceForm
            onSubmit={this.handleSubmit}
            grades={grades}
            teachers={teachers}
            statusCheckboxes={this.statusCheckboxes()}
            shouldCustomFiltersDisable={this.shouldCustomFiltersDisable()}
            initialValues={this.initialValues()}
            loadingGrades={loadingGrades}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { roster } = state.RosterCurrentBalanceState;
  return {
    grades: roster.grades,
    teachers: roster.teachers,
    formValues: getFormValues(ROSTER_CURRENT_BALANCE_FORM_NAME)(state),
    report: roster.report,
    loading: roster.loading,
    loadingGrades: roster.loadingGrades,
    errors: roster.errors,
  };
};

export const RosterCurrentBalance = withRouter(
  connect(mapStateToProps, {
    getTeachers,
    getGrades,
    change,
    getReport,
    clearReport,
    clearErrors,
    downloadReport,
  })(RosterCurrentBalanceContainer)
);



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/RosterCurrentBalance.js